<template>
  <div
    :style="`background: url(/icons/systems-store-card-${image}-image.jpg);
      background-size: 100% auto;
      background-position-y: 100%;`
    "
    class="system-store-card-container"
    v-if="subscription"
  >
    <div :class="['d-flex', type]">
      <div class="left-card-box">
        <div>
          <div class="title">{{ cardTitle }}</div>
          <div class="description" v-if="type != 'pro'">
            <template v-for="param in $t(`store_card.${type}`)">
              - {{ param }}
              <br />
            </template>
            <!-- - Онлайн оплата <br />
            - Онлайн чайові <br />- Замовлення страв та послуг <br />-
            Автоматичний переклад - QRWaiter AI ® <br />- Перевірка геолокації
            <br />- Автоматичне розпізнавання столів <br />- Інтеграція з
            POS-системами <br />- Формування клієнтської бази <br /><br />*Для
            користування потрібно замовити QR-стікери -->
            <p v-if="['inside', 'hotels'].includes(type)">
              <br />
              {{ $t("store_card.stickers_required") }}
            </p>
          </div>
          <div class="description" v-else>
            {{ $t("store_card.pro_title") }}
            <br />
            <br />
            - INSIDE
            <br />
            - TAKEAWAY
            <br />
            - DELIVERY
            <br />
            - RESERVE
          </div>
        </div>
        <DashboardButton
          v-if="status == 'initial'"
          :variant="type == 'inside' || type == 'pro' ? '' : 'black'"
          class="more-info-button"
          @click="status = 'connecting'"
        >
          {{ $t("store_card.details") }}</DashboardButton
        >
        <div class="price-per-month" v-else>
          ${{ subscription.price }}<span>/{{ $t("store_card.month") }}</span>
        </div>
      </div>
      <div
        v-if="status != 'initial'"
        :class="[
          'right-card-box',
          status == 'connected' ? 'black-background' : '',
        ]"
      >
        <div v-if="status == 'connecting'" class="box-content">
          <div :class="[type == 'inside' ? 'white-text' : '', 'description']">
            {{ $t(`store_card.${type}_long`) }}
          </div>
          <DashboardButton
            class="connect-button"
            @click="isModeActive = true"
            :variant="connectButtonClass"
            >{{ $t("store_card.connect") }}</DashboardButton
          >
        </div>
        <div v-else-if="status == 'connected'" class="box-content">
          <div>
            <div class="system-status">
              <div class="label">{{ $t("store_card.system_status") }}</div>
              <div class="info">{{ $t("store_card.connected") }}</div>
            </div>
            <div class="subscribe-status">
              <div class="label">
                {{ $t("store_card.subscription_status") }}
              </div>
              <div class="info c-green" v-if="subscriptionStatus == 'paid'">
                {{ $t("store_card.paid_until") }}
                {{ subscription.paid_until | formatDate
                }}{{
                  areRecurringPaymentsEnabled
                    ? ", " + $t("store_card.recurring_payment")
                    : ""
                }}
              </div>
              <div class="info c-red" v-if="subscriptionStatus == 'ended'">
                {{ $t("store_card.ended_at") }}
                {{ paidUntilSafe
                }}{{
                  areRecurringPaymentsEnabled
                    ? ", " + $t("store_card.recurring_payment")
                    : ""
                }}
              </div>
              <div class="info c-orange" v-if="subscriptionStatus == 'trial'">
                {{ $t("store_card.trial_until") }}
                {{ subscription.paid_until | formatDate }}
              </div>
            </div>
          </div>
          <div v-if="type == 'pro' ? true : !isProSubscriptionActive">
            <div class="description" v-if="subscriptionStatus == 'trial'">
              {{ $t("store_card.trial_bonus") }}
            </div>
            <div v-if="!areRecurringPaymentsEnabled" class="buttons-container">
              <DashboardButton
                class="connect-button"
                @click="openSubscribeForm"
                :variant="payButtonClass"
              >
                {{ $t("store_card.subscribe") }}
              </DashboardButton>
              <DashboardButton variant="danger" @click="isModeActive = false">{{
                $t("store_card.disconnect")
              }}</DashboardButton>
            </div>
            <div v-else class="buttons-container">
              <DashboardButton
                @click="$emit('changeCard', subscription)"
                class="connect-button"
                >{{ $t("store_card.change_card") }}</DashboardButton
              >
              <DashboardButton
                class="connect-button"
                @click="$emit('cancel', subscription)"
                variant="danger"
              >
                {{ $t("store_card.cancel") }}
              </DashboardButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";
import moment from "moment";

export default {
  components: {
    DashboardButton,
  },
  data() {
    return {
      status: "initial",
      cancel_modal: false,

      pro_active: false,
    };
  },
  props: {
    type: {
      type: String,
      default: "inside", // inside,reserve,delivery
    },
    image: {
      type: String,
      default: "inside",
    },
  },
  watch: {
    isModeActive() {
      console.log(this.isModeActive);
      if (this.isModeActive) {
        this.status = "connected";
      } else {
        this.status = "connecting";
      }
    },
  },
  methods: {
    openSubscribeForm() {
      this.$emit("subscribe", this.subscription);
      // window.location.href = `/api/subscription/form/${this.subscription._id}/html`;
    },
  },
  mounted() {
    if (this.isModeActive) this.status = "connected";
  },
  computed: {
    cardTitle() {
      if (this.type == 'hotels') return 'ROOMS';
      if (this.type == 'preorder') return 'TAKEAWAY';
      
      return this.type.toUpperCase(); 
    },
    subscription() {
      return this.$store.getters["subscriptions/all"][this.type];
    },
    isProUser() {
      return this.$store.getters['subscriptions/isProUser'];
    },
    proSubscription() {
      return this.$store.getters["subscriptions/all"]['pro'];
    },
    isProSubscriptionActive() {
      return !!this.proSubscription.liqpay_id;
    },  
    subscriptionStatus() {
      if (moment(this.subscription.trial_period_until).isAfter(moment())) {
        if (moment(this.subscription.trial_period_until).isBefore(
          this.subscription.paid_until
        )) {
          return 'paid';
        }
        
        return "trial";
      }

      if (moment(this.subscription.paid_until).isAfter(moment())) {
        return "paid";
      }

      return "ended";
    },
    areRecurringPaymentsEnabled() {
      return !!this.subscription.liqpay_id;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    payButtonClass() {
      return {
        inside: "success-fill",
        preorder: "preorder",
        delivery: "delivery",
        reserve: "reserve",
        pro: "danger-fill",
      }[this.type];
    },
    paidUntilSafe() {
      if (!this.subscription.paid_until) return '';

      return moment(this.subscription.paid_until).format('DD.MM.YYYY');
    },
    connectButtonClass() {
      return {
        inside: "success-fill",
        preorder: "black-fill",
        delivery: "black-fill",
        reserve: "black-fill",
        pro: "danger-fill",
      }[this.type];
    },
    isModeActive: {
      get() {
        if (!this.cafe || !this.cafe.modes) return false;
        if (this.type == "pro") {
          return (
            this.areRecurringPaymentsEnabled ||
            (
              +this.cafe.modes.inside +
              this.cafe.modes.preorder +
              this.cafe.modes.delivery +
              this.cafe.modes.reserve >=
              4
            )
          );
        }
        return this.cafe.modes[this.type];
      },
      set(value) {
        if (!value) this.$emit("disconnected");
        if (this.type == "pro") {
          this.$store.commit("toggleCafeMode", {
            mode: "inside",
            value,
          });
          this.$store.commit("toggleCafeMode", {
            mode: "preorder",
            value,
          });
          this.$store.commit("toggleCafeMode", {
            mode: "delivery",
            value,
          });
          this.$store.commit("toggleCafeMode", {
            mode: "reserve",
            value,
          });
          this.$store.dispatch("saveCafe");
          return;
        }
        this.$store.commit("toggleCafeMode", {
          mode: this.type,
          value,
        });
        this.$store.dispatch("saveCafe");

        this.$store.dispatch("auditlog/write", {
          type: value ? "mode_enable" : "mode_disable",
          payload: {
            mode: this.type,
          },
        });
      },
    },
  },
};
</script>
<style scoped>
.system-store-card-container {
  position: relative;
  width: 100%;
  min-height: 44.44444444444444vh;
  filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.25));
  border-radius: 1.666vh;
  margin-top: 3.3333333333333335vh;
}
.left-card-box {
  box-sizing: border-box;
  height: 44.44444444444444vh;
  width: 35%;
  background: rgba(29, 29, 27, 0.7);
  backdrop-filter: blur(15px);
  padding: 2.7777777777777777vh 3.3333333333333335vh;
  border-radius: 1.666vh 0 0 1.666vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right-card-box {
  box-sizing: border-box;
  height: 44.44444444444444vh;
  width: 65%;
  background: rgba(29, 29, 27, 0.7);
  backdrop-filter: blur(15px);
  border-radius: 0 1.666vh 1.666vh 0;
  padding: 2.7777777777777777vh 3.3333333333333335vh 2.7777777777777777vh 0;
}
.box-content {
  border-left: 0.11111vh solid #908f8d;
  height: 100%;
  padding-left: 3.3333333333333335vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.title {
  font-weight: normal;
  font-size: 4vh;
  line-height: 4.555vh;
  color: #ededed;
  margin-bottom: 2.2222222222222223vh;
}
.description {
  font-weight: normal;
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.white-text {
  color: #ededed;
}
.more-info-button {
  width: 100%;
}
.connect-button {
  width: 33.55555555555556vh;
}
.price-per-month {
  font-size: 5.555555555555555vh;
  line-height: 80%;
  color: #ededed;
}
.price-per-month span {
  font-size: 2.2222222222222223vh;
}
.system-status {
  margin-bottom: 2.2222222222222223vh;
}
.label {
  font-weight: normal;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
}
.info {
  font-weight: normal;
  font-size: 2.2222222222222223vh;
  line-height: 2.5555555555555554vh;
  color: #ededed;
}
.danger {
  color: #f96d1e;
}
.black-background {
  background: #1d1d1b !important;
}
.black-background .box-content {
  border: none;
}
.buttons-container {
  display: flex;
  width: 100%;
  margin-top: 2.2222vh;
}
.buttons-container button {
  width: calc(50% - 1.1111vh);
}
.buttons-container button:first-child {
  margin-right: 2.2222vh;
}
.reserve .right-card-box {
  background: rgba(255, 210, 168, 0.7);
  background: rgba(174, 204, 198, 0.7);
}
.reserve .left-card-box {
  background: rgba(255, 210, 168, 0.7);
  background: rgba(174, 204, 198, 0.7);
}
.reserve .box-content {
  border-color: #464646;
}

.reserve .left-card-box .title {
  color: #1d1d1b;
}
.reserve .left-card-box .description {
  color: #464646;
}
.reserve .right-card-box .description {
  color: #464646;
}
.reserve .left-card-box .price-per-month {
  color: #1d1d1b;
}
.preorder .right-card-box {
  background: rgba(255, 210, 168, 0.7);
}
.preorder .left-card-box {
  background: rgba(255, 210, 168, 0.7);
}
.preorder .box-content {
  border-color: #464646;
}

.preorder .left-card-box .title {
  color: #1d1d1b;
}
.preorder .left-card-box .description {
  color: #464646;
}
.preorder .right-card-box .description {
  color: #464646;
}
.preorder .left-card-box .price-per-month {
  color: #1d1d1b;
}
.delivery .right-card-box {
  background: rgba(203, 217, 230, 0.7);
}
.delivery .left-card-box {
  background: rgba(203, 217, 230, 0.7);
}
.delivery .box-content {
  border-color: #464646;
}
.delivery .left-card-box .title {
  color: #1d1d1b;
}
.delivery .left-card-box .description {
  color: #464646;
}
.delivery .right-card-box .description {
  color: #464646;
}
.delivery .left-card-box .price-per-month {
  color: #1d1d1b;
}

.pro .left-card-box .title {
  color: #e2223b;
}
.pro .left-card-box .price-per-month {
  color: #ededed;
}
</style>
